import ProductAdd from "features/Product/ProductAdd/ProductAdd";

const ProductAddPage: React.FC = () => {
  return <ProductAdd />;
};

export default ProductAddPage;
